// React
import React, {useState} from "react";
// Redux imports
import { useSelector, useDispatch } from "react-redux";
import { setProyecto } from "../../../redux/reducers/proyectos";

// import BooleanIcon from 'calcite-ui-icons-react/BooleanIcon';

import ActionBar, {
  Action,
  ActionGroup,
  // BottomActionGroup
} from 'calcite-react/ActionBar';

// Styled Components
import styled from "styled-components";

const ActionBarLeft = styled.div`
  // float:left;
  // display: inline-flex;
  // position: relative;
  // width: auto;
  // height: 100%;
  // text-align: center;
  // z-index: 2;
  // left: 0px;
  overflow: hidden;
  // background-color: #4c4c4c;
  // color: #fff;
`;

const ItemMenuOptsIcon = styled.div`
  width: 16px;
  height: 16px;
  background: transpararent;
  font-size:0.95rem;
  font-weight:700;
  text-align: center;
`;

const MenuLeftJornadasSalud = props => {
    // const isCollapsed = useSelector(state => state.proyectos.collapsed);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const activeAction = useSelector(state => state.proyectos.activeProyecto);
    const dispatch = useDispatch();

    const proyectosNames = {
      "":'Caracterización Social y Económica',
      "AUXILIO_OFTALMOLOGICO":"Aux. Oftalmológico",
			"AUXILIO_ODONTOLOGICO": "Aux. Odontológico",
			"MEDICAMENTOS": "Medicamentos",
			"EXAMENES": "Examenes",
      "COPAGOS": "Copagos",
      "CONFIGURACION": "Configuración del GRB", 
    };

    // useEffect(() => {
    //   dispatch(moduleLEFTPANELLoaded({activeModule:activeAction, headerTitle:proyectosNames[activeAction]}));
    // }, [dispatch]);

    const onToggleCollapse = (e) => {
      setIsCollapsed(!isCollapsed);
    };

    const turnOffModules = () => {
      // dispatch(moduleUSERSLoaded({loaded:false})); // Hide Users
      // dispatch(moduleBENEFICIARIOSLoaded({loaded:false}));
    }

    const actionSelected = (activeAction) => {
      dispatch(setProyecto({activeProyecto:activeAction, collapsed:isCollapsed, headerTitle:proyectosNames[activeAction]}));
      turnOffModules();
      switch (activeAction) {
        case 'AUXILIO_OFTALMOLOGICO':
          console.log('AUXILIO_OFTALMOLOGICO');
          break;
        case 'AUXILIO_ODONTOLOGICO':
          console.log('AUXILIO_ODONTOLOGICO');
          break;
        case 'MEDICAMENTOS':
          console.log('MEDICAMENTOS');
          break;
        case 'EXAMENES':
          console.log('EXAMENES');
          break;
        case 'COPAGOS':
          console.log('COPAGOS');
          break;
        default:
          break;
      }
    };

    return (
      <ActionBarLeft>
      <ActionBar 
        // showCollapser={false}
        collapseLabel='Ocultar' 
        expandLabel='Expandir' 
        collapsed={isCollapsed}
        onToggleCollapse={onToggleCollapse}
      >
        <ActionGroup>
          <Action
            onClick={() => actionSelected('AUXILIO_OFTALMOLOGICO')}
            active={activeAction === 'AUXILIO_OFTALMOLOGICO'}
            icon={<ItemMenuOptsIcon>OF</ItemMenuOptsIcon>}
          >
            Auxilio Oftalmológico
          </Action>
          <Action 
              onClick={() => actionSelected('AUXILIO_ODONTOLOGICO')}
              active={activeAction === 'AUXILIO_ODONTOLOGICO'}
              icon={<ItemMenuOptsIcon>OD</ItemMenuOptsIcon>}
            >
              Auxilio Odontológico
          </Action>
          <Action
            onClick={() => actionSelected('MEDICAMENTOS')}
            active={activeAction === 'MEDICAMENTOS'}
            icon={<ItemMenuOptsIcon>M</ItemMenuOptsIcon>}
          >
            Medicamentos
          </Action>
          <Action
            onClick={() => actionSelected('EXAMENES')}
            active={activeAction === 'EXAMENES'}
            icon={<ItemMenuOptsIcon>E</ItemMenuOptsIcon>}
            >Examenes
          </Action>
          <Action
            onClick={() => actionSelected('COPAGOS')}
            active={activeAction === 'COPAGOS'}
            icon={<ItemMenuOptsIcon>C</ItemMenuOptsIcon>}
            >Copagos
          </Action>
        </ActionGroup>
        {/* <BottomActionGroup>
        <Action icon={<GearIcon />}>Configuración</Action>
      </BottomActionGroup> */}
      </ActionBar>
      </ActionBarLeft>
    )

}

export default MenuLeftJornadasSalud;